import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'

export const APP_NAME = 'ODE';
export const API_BASE_URL = env.API_ENDPOINT_URL
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const REDIRECT_URL_KEY = 'redirect'
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/default`;
export const UNAUTHENTICATED_ENTRY = '/login'

/*export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'en',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#3e82f7',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR,
	blankLayout: false
};*/
export const THEME_CONFIG = {
	"navType": "SIDE",
	"sideNavTheme": "SIDE_NAV_LIGHT",
	"navCollapsed": false,
	"topNavColor": "#3e82f7",
	"headerNavColor": "#01a8ffff",
	"locale": "en",
	"currentTheme": "light",
	"direction": "ltr",
	"blankLayout": false,
	"mobileNav": false,
};


export const LIST_BANKS = [
	{
		value: "BNI",
		label: "Bank BNI",
	},
	{
		value: "BRI",
		label: "Bank BRI",
	},
	{
		value: "MANDIRI",
		label: "Bank Mandiri",
	},
	{
		value: "CIMB",
		label: "Bank CIMB",
	},
	{
		value: "PERMATA",
		label: "Bank Permata",
	},
	{
		value: "BSI",
		label: "Bank Syariah Indonesia",
	},
	{
		value: "BJB",
		label: "BJB",
	},
]